"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNSELECTABLE_STYLE = exports.UNSELECTABLE_ATTRIBUTE = void 0;
exports.default = generateSelector;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _KeyCode = _interopRequireDefault(require("rc-util/lib/KeyCode"));
var _classnames = _interopRequireDefault(require("classnames"));
var _useMergedState5 = _interopRequireDefault(require("rc-util/lib/hooks/useMergedState"));
var _Selector = _interopRequireDefault(require("./Selector"));
var _SelectTrigger = _interopRequireDefault(require("./SelectTrigger"));
var _generator = require("./interface/generator");
var _commonUtil = require("./utils/commonUtil");
var _useLock3 = _interopRequireDefault(require("./hooks/useLock"));
var _useDelayReset3 = _interopRequireDefault(require("./hooks/useDelayReset"));
var _useLayoutEffect = _interopRequireDefault(require("./hooks/useLayoutEffect"));
var _valueUtil = require("./utils/valueUtil");
var _useSelectTriggerControl = _interopRequireDefault(require("./hooks/useSelectTriggerControl"));
var _useCacheDisplayValue = _interopRequireDefault(require("./hooks/useCacheDisplayValue"));
var _useCacheOptions = _interopRequireDefault(require("./hooks/useCacheOptions"));
var _StyledSelect = require("../StyledSelect");
var _Tooltip = _interopRequireDefault(require("../../Tooltip"));
var _excluded = ["prefixCls", "theme", "template", "size", "className", "id", "open", "defaultOpen", "options", "children", "mode", "value", "defaultValue", "labelInValue", "hideSelectedOptions", "showSelectAll", "autoAdd", "upperCase", "showSearch", "inputValue", "searchValue", "filterOption", "filterSort", "optionFilterProp", "autoClearSearchValue", "onSearch", "allowClear", "clearIcon", "showArrow", "customIcon", "inputIcon", "menuItemSelectedIcon", "disabled", "loading", "defaultActiveFirstOption", "notFoundContent", "optionLabelProp", "backfill", "tabIndex", "getInputElement", "getPopupContainer", "listHeight", "listItemHeight", "animation", "transitionName", "virtual", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownRenderHeader", "dropdownAlign", "showAction", "direction", "tokenSeparators", "tagRender", "onPopupScroll", "onDropdownVisibleChange", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown", "onChange", "onSelect", "onDeselect", "onClear", "internalProps", "copyable", "backgroundColorType", "copyFormatter", "addonBefore", "addonAfter", "type", "showCheck", "viewMode", "scroll"];
/**
 * To match accessibility requirement, we always provide an input in the component.
 * Other element will not set `tabIndex` to avoid `onBlur` sequence problem.
 * For focused select, we set `aria-live="polite"` to update the accessibility content.
 *
 * ref:
 * - keyboard: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/listbox_role#Keyboard_interactions
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var UNSELECTABLE_STYLE = exports.UNSELECTABLE_STYLE = {
  userSelect: 'none',
  WebkitUserSelect: 'none'
};
var UNSELECTABLE_ATTRIBUTE = exports.UNSELECTABLE_ATTRIBUTE = {
  unselectable: 'on'
};
var DEFAULT_OMIT_PROPS = ['removeIcon', 'placeholder', 'autoFocus', 'maxTagCount', 'maxTagTextLength', 'maxTagPlaceholder', 'choiceTransitionName', 'onInputKeyDown', 'tabIndex'];
/**
 * This function is in internal usage.
 * Do not use it in your prod env since we may refactor this.
 */
function generateSelector(config) {
  var defaultPrefixCls = config.prefixCls,
    OptionList = config.components.optionList,
    convertChildrenToData = config.convertChildrenToData,
    flattenOptions = config.flattenOptions,
    getLabeledValue = config.getLabeledValue,
    filterOptions = config.filterOptions,
    isValueDisabled = config.isValueDisabled,
    findValueOption = config.findValueOption,
    warningProps = config.warningProps,
    fillOptionsWithMissingValue = config.fillOptionsWithMissingValue,
    omitDOMProps = config.omitDOMProps;

  // Use raw define since `React.FC` not support generic
  function Select(props, ref) {
    var _classNames2;
    var _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? defaultPrefixCls : _props$prefixCls,
      theme = props.theme,
      template = props.template,
      size = props.size,
      className = props.className,
      id = props.id,
      open = props.open,
      defaultOpen = props.defaultOpen,
      options = props.options,
      children = props.children,
      mode = props.mode,
      value = props.value,
      defaultValue = props.defaultValue,
      labelInValue = props.labelInValue,
      hideSelectedOptions = props.hideSelectedOptions,
      _props$showSelectAll = props.showSelectAll,
      showSelectAll = _props$showSelectAll === void 0 ? false : _props$showSelectAll,
      _props$autoAdd = props.autoAdd,
      autoAdd = _props$autoAdd === void 0 ? false : _props$autoAdd,
      _props$upperCase = props.upperCase,
      upperCase = _props$upperCase === void 0 ? false : _props$upperCase,
      showSearch = props.showSearch,
      inputValue = props.inputValue,
      searchValue = props.searchValue,
      filterOption = props.filterOption,
      filterSort = props.filterSort,
      _props$optionFilterPr = props.optionFilterProp,
      optionFilterProp = _props$optionFilterPr === void 0 ? 'value' : _props$optionFilterPr,
      _props$autoClearSearc = props.autoClearSearchValue,
      autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc,
      onSearch = props.onSearch,
      allowClear = props.allowClear,
      clearIcon = props.clearIcon,
      showArrow = props.showArrow,
      customIcon = props.customIcon,
      inputIcon = props.inputIcon,
      menuItemSelectedIcon = props.menuItemSelectedIcon,
      disabled = props.disabled,
      loading = props.loading,
      defaultActiveFirstOption = props.defaultActiveFirstOption,
      _props$notFoundConten = props.notFoundContent,
      notFoundContent = _props$notFoundConten === void 0 ? 'Not Found' : _props$notFoundConten,
      optionLabelProp = props.optionLabelProp,
      backfill = props.backfill,
      tabIndex = props.tabIndex,
      getInputElement = props.getInputElement,
      getPopupContainer = props.getPopupContainer,
      _props$listHeight = props.listHeight,
      listHeight = _props$listHeight === void 0 ? 200 : _props$listHeight,
      _props$listItemHeight = props.listItemHeight,
      listItemHeight = _props$listItemHeight === void 0 ? 20 : _props$listItemHeight,
      animation = props.animation,
      transitionName = props.transitionName,
      virtual = props.virtual,
      dropdownStyle = props.dropdownStyle,
      dropdownClassName = props.dropdownClassName,
      dropdownMatchSelectWidth = props.dropdownMatchSelectWidth,
      dropdownRender = props.dropdownRender,
      dropdownRenderHeader = props.dropdownRenderHeader,
      dropdownAlign = props.dropdownAlign,
      _props$showAction = props.showAction,
      showAction = _props$showAction === void 0 ? [] : _props$showAction,
      direction = props.direction,
      tokenSeparators = props.tokenSeparators,
      tagRender = props.tagRender,
      onPopupScroll = props.onPopupScroll,
      onDropdownVisibleChange = props.onDropdownVisibleChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onKeyUp = props.onKeyUp,
      onKeyDown = props.onKeyDown,
      onMouseDown = props.onMouseDown,
      onChange = props.onChange,
      onSelect = props.onSelect,
      onDeselect = props.onDeselect,
      onClear = props.onClear,
      _props$internalProps = props.internalProps,
      internalProps = _props$internalProps === void 0 ? {} : _props$internalProps,
      copyable = props.copyable,
      backgroundColorType = props.backgroundColorType,
      copyFormatter = props.copyFormatter,
      addonBefore = props.addonBefore,
      addonAfter = props.addonAfter,
      type = props.type,
      showCheck = props.showCheck,
      viewMode = props.viewMode,
      scroll = props.scroll,
      restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
    var useInternalProps = internalProps.mark === _generator.INTERNAL_PROPS_MARK;
    var activeAutoAdd = autoAdd;
    var domProps = omitDOMProps ? omitDOMProps(restProps) : restProps;
    DEFAULT_OMIT_PROPS.forEach(function (prop) {
      delete domProps[prop];
    });
    var containerRef = (0, _react.useRef)(null);
    var triggerRef = (0, _react.useRef)(null);
    var selectorRef = (0, _react.useRef)(null);
    var listRef = (0, _react.useRef)(null);
    var tokenWithEnter = (0, _react.useMemo)(function () {
      return (tokenSeparators || []).some(function (tokenSeparator) {
        return ['\n', '\r\n'].includes(tokenSeparator);
      });
    }, [tokenSeparators]);

    /** Used for component focused management */
    var _useDelayReset = (0, _useDelayReset3.default)(),
      _useDelayReset2 = (0, _slicedToArray2.default)(_useDelayReset, 3),
      mockFocused = _useDelayReset2[0],
      setMockFocused = _useDelayReset2[1],
      cancelSetMockFocused = _useDelayReset2[2];

    // Inner id for accessibility usage. Only work in client side
    var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      innerId = _useState2[0],
      setInnerId = _useState2[1];
    (0, _react.useEffect)(function () {
      setInnerId("rc_select_".concat((0, _commonUtil.getUUID)()));
    }, []);
    var mergedId = id || innerId;

    // optionLabelProp
    var mergedOptionLabelProp = optionLabelProp;
    if (mergedOptionLabelProp === undefined) {
      mergedOptionLabelProp = options ? 'label' : 'children';
    }

    // labelInValue
    var mergedLabelInValue = mode === 'combobox' ? false : labelInValue;
    var isMultiple = mode === 'tags' || mode === 'multiple';
    var mergedShowSearch = showSearch !== undefined ? showSearch : isMultiple || mode === 'combobox';

    // ============================== Ref ===============================
    var selectorDomRef = (0, _react.useRef)(null);
    React.useImperativeHandle(ref, function () {
      var _listRef$current;
      return {
        focus: selectorRef.current.focus,
        blur: selectorRef.current.blur,
        scrollTo: (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollTo
      };
    });

    // ============================= Value ==============================
    var _useMergedState = (0, _useMergedState5.default)(defaultValue, {
        value: value
      }),
      _useMergedState2 = (0, _slicedToArray2.default)(_useMergedState, 2),
      mergedValue = _useMergedState2[0],
      setMergedValue = _useMergedState2[1];

    /** Unique raw values */
    var _useMemo = (0, _react.useMemo)(function () {
        return (0, _commonUtil.toInnerValue)(mergedValue, {
          labelInValue: mergedLabelInValue,
          combobox: mode === 'combobox'
        });
      }, [mergedValue, mergedLabelInValue]),
      _useMemo2 = (0, _slicedToArray2.default)(_useMemo, 2),
      mergedRawValue = _useMemo2[0],
      mergedValueMap = _useMemo2[1];
    /** We cache a set of raw values to speed up check */
    var rawValues = (0, _react.useMemo)(function () {
      return new Set(mergedRawValue);
    }, [mergedRawValue]);

    // ============================= Option =============================
    // Set by option list active, it will merge into search input when mode is `combobox`
    var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      activeValue = _useState4[0],
      setActiveValue = _useState4[1];
    var _useState5 = (0, _react.useState)(''),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      innerSearchValue = _useState6[0],
      setInnerSearchValue = _useState6[1];
    var mergedSearchValue = innerSearchValue;
    if (mode === 'combobox' && mergedValue !== undefined) {
      mergedSearchValue = mergedValue;
    } else if (searchValue !== undefined) {
      mergedSearchValue = searchValue;
    } else if (inputValue) {
      mergedSearchValue = inputValue;
    }
    var mergedOptions = (0, _react.useMemo)(function () {
      var newOptions = options;
      if (newOptions === undefined) {
        newOptions = convertChildrenToData(children);
      }

      /**
       * `tags` should fill un-list item.
       * This is not cool here since TreeSelect do not need this
       */
      if ((mode === 'tags' || activeAutoAdd) && fillOptionsWithMissingValue) {
        newOptions = fillOptionsWithMissingValue(newOptions, mergedValue, mergedOptionLabelProp, labelInValue);
      }
      return newOptions || [];
    }, [options, children, mode, mergedValue]);
    var mergedFlattenOptions = (0, _react.useMemo)(function () {
      return flattenOptions(mergedOptions, props);
    }, [mergedOptions]);
    var getValueOption = (0, _useCacheOptions.default)(mergedFlattenOptions);

    // Display options for OptionList
    var displayOptions = (0, _react.useMemo)(function () {
      if (!mergedSearchValue || !mergedShowSearch) {
        return (0, _toConsumableArray2.default)(mergedOptions);
      }
      var filteredOptions = filterOptions(mergedSearchValue, mergedOptions, {
        optionFilterProp: optionFilterProp,
        filterOption: mode === 'combobox' && filterOption === undefined ? function () {
          return true;
        } : filterOption
      });
      if ((mode === 'tags' || activeAutoAdd) && filteredOptions.every(function (opt) {
        return opt[optionFilterProp] !== mergedSearchValue;
      })) {
        filteredOptions.unshift({
          value: mergedSearchValue,
          label: mergedSearchValue,
          key: '__RC_SELECT_TAG_PLACEHOLDER__'
        });
      }
      if (filterSort && Array.isArray(filteredOptions)) {
        return (0, _toConsumableArray2.default)(filteredOptions).sort(filterSort);
      }
      return filteredOptions;
    }, [mergedOptions, mergedSearchValue, mode, mergedShowSearch, filterSort]);
    var displayFlattenOptions = (0, _react.useMemo)(function () {
      return flattenOptions(displayOptions, props);
    }, [displayOptions]);
    (0, _react.useEffect)(function () {
      if (listRef.current && listRef.current.scrollTo) {
        listRef.current.scrollTo(0);
      }
    }, [mergedSearchValue]);

    // ============================ Selector ============================
    var displayValues = (0, _react.useMemo)(function () {
      var tmpValues = mergedRawValue.map(function (val) {
        var valueOptions = getValueOption([val]);
        var displayValue = getLabeledValue(val, {
          options: valueOptions,
          prevValueMap: mergedValueMap,
          labelInValue: mergedLabelInValue,
          optionLabelProp: mergedOptionLabelProp
        });
        return _objectSpread(_objectSpread({}, displayValue), {}, {
          disabled: isValueDisabled(val, valueOptions)
        });
      });
      if (!mode && tmpValues.length === 1 && tmpValues[0].value === null && tmpValues[0].label === null) {
        return [];
      }
      return tmpValues;
    }, [mergedValue, mergedOptions, mode]);

    // Polyfill with cache label
    displayValues = (0, _useCacheDisplayValue.default)(displayValues);
    var triggerSelect = function triggerSelect(newValue, isSelect, source) {
      var newValueOption = getValueOption([newValue]);
      var outOption = findValueOption([newValue], newValueOption)[0];
      if (!internalProps.skipTriggerSelect) {
        // Skip trigger `onSelect` or `onDeselect` if configured
        var selectValue = mergedLabelInValue ? getLabeledValue(newValue, {
          options: newValueOption,
          prevValueMap: mergedValueMap,
          labelInValue: mergedLabelInValue,
          optionLabelProp: mergedOptionLabelProp
        }) : newValue;
        if (isSelect && onSelect) {
          onSelect(selectValue, outOption);
        } else if (!isSelect && onDeselect) {
          onDeselect(selectValue, outOption);
        }
      }

      // Trigger internal event
      if (useInternalProps) {
        if (isSelect && internalProps.onRawSelect) {
          internalProps.onRawSelect(newValue, outOption, source);
        } else if (!isSelect && internalProps.onRawDeselect) {
          internalProps.onRawDeselect(newValue, outOption, source);
        }
      }
    };

    // We need cache options here in case user update the option list
    var _useState7 = (0, _react.useState)([]),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      prevValueOptions = _useState8[0],
      setPrevValueOptions = _useState8[1];
    var triggerChange = function triggerChange(newRawValues) {
      if (useInternalProps && internalProps.skipTriggerChange) {
        return;
      }
      var newRawValuesOptions = getValueOption(newRawValues);
      var outValues = (0, _commonUtil.toOuterValues)(Array.from(newRawValues), {
        labelInValue: mergedLabelInValue,
        options: newRawValuesOptions,
        getLabeledValue: getLabeledValue,
        prevValueMap: mergedValueMap,
        optionLabelProp: mergedOptionLabelProp
      });
      var outValue = isMultiple ? outValues : outValues[0];
      // Skip trigger if prev & current value is both empty
      if (onChange && (mergedRawValue.length !== 0 || outValues.length !== 0)) {
        var outOptions = findValueOption(newRawValues, newRawValuesOptions, {
          prevValueOptions: prevValueOptions
        });

        // Tümünü seçme durumu için eklendi.
        if (isMultiple && (showSelectAll === true || (0, _typeof2.default)(showSelectAll) === 'object') && newRawValues.includes('*')) {
          outOptions = displayOptions.filter(function (item) {
            return item.value !== '*';
          });
          outValue = displayOptions.reduce(function (acc, item) {
            if (item.value && item.value !== '*') acc.push(item.value);
            if (item.options && item.options.length > 0) {
              var _item$options;
              // alt seçenekler
              item === null || item === void 0 ? void 0 : (_item$options = item.options) === null || _item$options === void 0 ? void 0 : _item$options.forEach(function (subItem) {
                if (subItem.value !== '*') acc.push(subItem.value);
              });
            }
            return acc;
          }, []);
        }

        // We will cache option in case it removed by ajax
        setPrevValueOptions(outOptions.map(function (option, index) {
          var clone = _objectSpread({}, option);
          Object.defineProperty(clone, '_INTERNAL_OPTION_VALUE_', {
            get: function get() {
              return outValue[index];
            }
          });
          return clone;
        }));
        onChange(outValue, isMultiple ? outOptions : outOptions[0]);
      }
      setMergedValue(outValue);
    };
    var onInternalSelect = function onInternalSelect(newValue, _ref) {
      var selected = _ref.selected,
        source = _ref.source;
      if (disabled) {
        return;
      }
      var newRawValue;
      if (isMultiple) {
        newRawValue = new Set(mergedRawValue);
        if (selected) {
          newRawValue.add(newValue);
        } else {
          newRawValue.delete(newValue);
        }
      } else {
        newRawValue = new Set();
        newRawValue.add(newValue);
      }

      // Multiple always trigger change and single should change if value changed
      if (isMultiple || !isMultiple && Array.from(mergedRawValue)[0] !== newValue) {
        triggerChange(Array.from(newRawValue));
      }

      // Trigger `onSelect`. Single mode always trigger select
      triggerSelect(newValue, !isMultiple || selected, source);

      // Clean search value if single or configured
      if (mode === 'combobox') {
        setInnerSearchValue(String(newValue));
        setActiveValue('');
      } else if (!isMultiple || autoClearSearchValue) {
        setInnerSearchValue('');
        setActiveValue('');
      }
    };
    var onInternalOptionSelect = function onInternalOptionSelect(newValue, info) {
      onInternalSelect(newValue, _objectSpread(_objectSpread({}, info), {}, {
        source: 'option'
      }));
    };
    var onInternalSelectionSelect = function onInternalSelectionSelect(newValue, info) {
      onInternalSelect(newValue, _objectSpread(_objectSpread({}, info), {}, {
        source: 'selection'
      }));
    };

    // ============================= Input ==============================
    // Only works in `combobox`
    var customizeInputElement = mode === 'combobox' && getInputElement && getInputElement() || null;

    // ============================== Open ==============================
    var _useMergedState3 = (0, _useMergedState5.default)(undefined, {
        defaultValue: defaultOpen,
        value: open
      }),
      _useMergedState4 = (0, _slicedToArray2.default)(_useMergedState3, 2),
      innerOpen = _useMergedState4[0],
      setInnerOpen = _useMergedState4[1];
    var mergedOpen = innerOpen;

    // Not trigger `open` in `combobox` when `notFoundContent` is empty
    var emptyListContent = !notFoundContent && !displayOptions.length;
    if (disabled || viewMode || emptyListContent && mergedOpen && mode === 'combobox') {
      mergedOpen = false;
    }
    var triggerOpen = emptyListContent ? false : mergedOpen;
    var onToggleOpen = function onToggleOpen(newOpen) {
      var nextOpen = newOpen !== undefined ? newOpen : !mergedOpen;
      if (innerOpen !== nextOpen && !disabled) {
        setInnerOpen(nextOpen);
        if (onDropdownVisibleChange) {
          onDropdownVisibleChange(nextOpen);
        }
      }
    };
    (0, _useSelectTriggerControl.default)([containerRef.current, triggerRef.current && triggerRef.current.getPopupElement()], triggerOpen, onToggleOpen);

    // ============================= Search =============================
    var triggerSearch = function triggerSearch(searchText, fromTyping, isCompositing) {
      var ret = true;
      var newSearchText = searchText;
      setActiveValue(null);

      // Check if match the `tokenSeparators`
      var patchLabels = isCompositing ? null : (0, _valueUtil.getSeparatedContent)(searchText, tokenSeparators);
      var patchRawValues = patchLabels;
      if (mode === 'combobox') {
        // Only typing will trigger onChange
        if (fromTyping) {
          triggerChange([newSearchText]);
        }
      } else if (patchLabels) {
        newSearchText = '';
        if (mode !== 'tags') {
          patchRawValues = patchLabels.map(function (label) {
            var item = mergedFlattenOptions.find(function (_ref2) {
              var data = _ref2.data;
              return data[mergedOptionLabelProp] === label;
            });
            return item ? item.data.value : null;
          }).filter(function (val) {
            return val !== null;
          });
        }
        var newRawValues = Array.from(new Set([].concat((0, _toConsumableArray2.default)(mergedRawValue), (0, _toConsumableArray2.default)(patchRawValues))));
        triggerChange(newRawValues);
        newRawValues.forEach(function (newRawValue) {
          triggerSelect(newRawValue, true, 'input');
        });

        // Should close when paste finish
        onToggleOpen(false);

        // Tell Selector that break next actions
        ret = false;
      }
      setInnerSearchValue(newSearchText);
      if (onSearch && mergedSearchValue !== newSearchText) {
        onSearch(newSearchText);
      }
      return ret;
    };

    // Only triggered when menu is closed & mode is tags
    // If menu is open, OptionList will take charge
    // If mode isn't tags, press enter is not meaningful when you can't see any option
    var onSearchSubmit = function onSearchSubmit(searchText) {
      var newRawValues = Array.from(new Set([].concat((0, _toConsumableArray2.default)(mergedRawValue), [searchText])));
      triggerChange(newRawValues);
      newRawValues.forEach(function (newRawValue) {
        triggerSelect(newRawValue, true, 'input');
      });
      setInnerSearchValue('');
    };

    // Close dropdown when disabled change
    (0, _react.useEffect)(function () {
      if (innerOpen && !!disabled) {
        setInnerOpen(false);
      }
    }, [disabled]);

    // Close will clean up single mode search text
    (0, _react.useEffect)(function () {
      if (!mergedOpen && !isMultiple && mode !== 'combobox') {
        triggerSearch('', false, false);
      }
    }, [mergedOpen]);

    // ============================ Keyboard ============================
    /**
     * We record input value here to check if can press to clean up by backspace
     * - null: Key is not down, this is reset by key up
     * - true: Search text is empty when first time backspace down
     * - false: Search text is not empty when first time backspace down
     */
    var _useLock = (0, _useLock3.default)(),
      _useLock2 = (0, _slicedToArray2.default)(_useLock, 2),
      getClearLock = _useLock2[0],
      setClearLock = _useLock2[1];

    // KeyDown
    var onInternalKeyDown = function onInternalKeyDown(event) {
      var clearLock = getClearLock();
      var which = event.which;

      // We only manage open state here, close logic should handle by list component
      if (!mergedOpen && which === _KeyCode.default.ENTER) {
        onToggleOpen(true);
      }
      setClearLock(!!mergedSearchValue);

      // Remove value by `backspace`
      if (which === _KeyCode.default.BACKSPACE && !clearLock && isMultiple && !mergedSearchValue && mergedRawValue.length) {
        var removeInfo = (0, _commonUtil.removeLastEnabledValue)(displayValues, mergedRawValue);
        if (removeInfo.removedValue !== null) {
          triggerChange(removeInfo.values);
          triggerSelect(removeInfo.removedValue, false, 'input');
        }
      }
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      if (mergedOpen && listRef.current) {
        var _listRef$current2;
        (_listRef$current2 = listRef.current).onKeyDown.apply(_listRef$current2, [event].concat(rest));
      }
      if (onKeyDown) {
        onKeyDown.apply(void 0, [event].concat(rest));
      }
    };

    // KeyUp
    var onInternalKeyUp = function onInternalKeyUp(event) {
      for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        rest[_key2 - 1] = arguments[_key2];
      }
      if (mergedOpen && listRef.current) {
        var _listRef$current3;
        (_listRef$current3 = listRef.current).onKeyUp.apply(_listRef$current3, [event].concat(rest));
      }
      if (onKeyUp) {
        onKeyUp.apply(void 0, [event].concat(rest));
      }
    };

    // ========================== Focus / Blur ==========================
    /** Record real focus status */
    var focusRef = (0, _react.useRef)(false);
    var onContainerFocus = function onContainerFocus() {
      setMockFocused(true);
      if (!disabled) {
        if (onFocus && !focusRef.current) {
          onFocus.apply(void 0, arguments);
        }

        // `showAction` should handle `focus` if set
        if (showAction.includes('focus')) {
          onToggleOpen(true);
        }
      }
      focusRef.current = true;
    };
    var onContainerBlur = function onContainerBlur() {
      setMockFocused(false, function () {
        focusRef.current = false;
        onToggleOpen(false);
      });
      if (disabled) {
        return;
      }
      if (mergedSearchValue) {
        // `tags` mode should move `searchValue` into values
        if (mode === 'tags') {
          triggerSearch('', false, false);
          triggerChange(Array.from(new Set([].concat((0, _toConsumableArray2.default)(mergedRawValue), [mergedSearchValue]))));
        } else if (mode === 'multiple') {
          // `multiple` mode only clean the search value but not trigger event
          setInnerSearchValue('');
        }
      }
      if (onBlur) {
        onBlur.apply(void 0, arguments);
      }
    };
    var activeTimeoutIds = [];
    (0, _react.useEffect)(function () {
      return function () {
        activeTimeoutIds.forEach(function (timeoutId) {
          return clearTimeout(timeoutId);
        });
        activeTimeoutIds.splice(0, activeTimeoutIds.length);
      };
    }, []);
    var onInternalMouseDown = function onInternalMouseDown(event) {
      var target = event.target;
      var popupElement = triggerRef.current && triggerRef.current.getPopupElement();

      // We should give focus back to selector if clicked item is not focusable
      if (popupElement && popupElement.contains(target)) {
        var timeoutId = setTimeout(function () {
          var index = activeTimeoutIds.indexOf(timeoutId);
          if (index !== -1) {
            activeTimeoutIds.splice(index, 1);
          }
          cancelSetMockFocused();
          if (!popupElement.contains(document.activeElement)) {
            selectorRef.current.focus();
          }
        });
        activeTimeoutIds.push(timeoutId);
      }
      if (onMouseDown) {
        for (var _len3 = arguments.length, restArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          restArgs[_key3 - 1] = arguments[_key3];
        }
        onMouseDown.apply(void 0, [event].concat(restArgs));
      }
    };

    // ========================= Accessibility ==========================
    var _useState9 = (0, _react.useState)(0),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      accessibilityIndex = _useState10[0],
      setAccessibilityIndex = _useState10[1];
    var mergedDefaultActiveFirstOption = defaultActiveFirstOption !== undefined ? defaultActiveFirstOption : mode !== 'combobox';
    var onActiveValue = function onActiveValue(active, index) {
      var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref3$source = _ref3.source,
        source = _ref3$source === void 0 ? 'keyboard' : _ref3$source;
      setAccessibilityIndex(index);
      if (backfill && mode === 'combobox' && active !== null && source === 'keyboard') {
        setActiveValue(String(active));
      }
    };

    // ============================= Popup ==============================
    var _useState11 = (0, _react.useState)(null),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      containerWidth = _useState12[0],
      setContainerWidth = _useState12[1];
    var _useState13 = (0, _react.useState)({}),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      forceUpdate = _useState14[1];
    // We need force update here since popup dom is render async
    function onPopupMouseEnter() {
      forceUpdate({});
    }
    (0, _useLayoutEffect.default)(function () {
      if (triggerOpen) {
        var newWidth = Math.ceil(containerRef.current.offsetWidth);
        if (containerWidth !== newWidth) {
          setContainerWidth(newWidth);
        }
      }
    }, [triggerOpen]);
    var shouldVirtual = virtual !== false && dropdownMatchSelectWidth !== false && scroll;
    var popupNode = /*#__PURE__*/React.createElement(OptionList, {
      ref: listRef,
      prefixCls: prefixCls,
      theme: theme,
      id: mergedId,
      open: mergedOpen,
      childrenAsData: !options,
      options: displayOptions,
      flattenOptions: displayFlattenOptions,
      multiple: isMultiple,
      values: rawValues,
      height: listHeight,
      hideSelectedOptions: hideSelectedOptions,
      showSelectAll: showSelectAll,
      autoAdd: activeAutoAdd,
      itemHeight: listItemHeight,
      onSelect: onInternalOptionSelect,
      onToggleOpen: onToggleOpen,
      onActiveValue: onActiveValue,
      defaultActiveFirstOption: mergedDefaultActiveFirstOption,
      notFoundContent: notFoundContent,
      onScroll: onPopupScroll,
      searchValue: mergedSearchValue,
      menuItemSelectedIcon: menuItemSelectedIcon,
      virtual: shouldVirtual,
      onMouseEnter: onPopupMouseEnter,
      showCheck: showCheck
    });

    // ============================= Clear ==============================

    var clearNode;
    var onClearMouseDown = function onClearMouseDown() {
      // Trigger internal `onClear` event
      if (useInternalProps && internalProps.onClear) {
        internalProps.onClear();
      }
      if (onClear) {
        onClear();
      }
      triggerChange([]);
      triggerSearch('', false, false);
    };
    if (!disabled && allowClear && (mergedRawValue.length || mergedSearchValue)) {
      clearNode = /*#__PURE__*/React.createElement(_StyledSelect.StyledSelectionClear, (0, _extends2.default)({
        $theme: theme,
        style: UNSELECTABLE_STYLE
      }, UNSELECTABLE_ATTRIBUTE, {
        onMouseDown: onClearMouseDown,
        name: "close",
        className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-selection__clear"), !!prefixCls))
      }));
    }

    // ============================= Arrow ==============================
    var mergedShowArrow = showArrow !== undefined ? showArrow : loading || !isMultiple && mode !== 'combobox';
    var arrowNode;
    if (customIcon !== undefined) {
      if (typeof customIcon === 'string') {
        arrowNode = /*#__PURE__*/React.createElement(_StyledSelect.StyledCustomIcon, {
          name: customIcon
        });
      } else if (/*#__PURE__*/React.isValidElement(customIcon)) {
        arrowNode = /*#__PURE__*/React.createElement(_StyledSelect.CustomIconWrapper, null, customIcon);
      }
    } else if (mergedShowArrow) {
      arrowNode = /*#__PURE__*/React.createElement(_StyledSelect.StyledArrow, {
        $theme: theme,
        name: "angle-down",
        key: "arrow"
      });
    }

    // ============================ Warning =============================
    if (process.env.NODE_ENV !== 'production' && warningProps) {
      warningProps(props);
    }

    // ============================= Render =============================
    var mergedClassName = (0, _classnames.default)(prefixCls, className, (_classNames2 = {}, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_classNames2, "".concat(prefixCls, "-focused"), mockFocused), "".concat(prefixCls, "-multiple"), isMultiple), "".concat(prefixCls, "-single"), !isMultiple), "".concat(prefixCls, "-allow-clear"), allowClear), "".concat(prefixCls, "-show-arrow"), mergedShowArrow), "".concat(prefixCls, "-custom-icon"), customIcon), "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-loading"), loading), "".concat(prefixCls, "-open"), mergedOpen), "".concat(prefixCls, "-customize-input"), customizeInputElement), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_classNames2, "".concat(prefixCls, "-show-search"), mergedShowSearch), "ykb-ui-select-container", true), "table-xs", size === 'xsmall')));
    var copyItem;
    if (props.mode == 'multiple') {
      var _displayValues;
      copyItem = (_displayValues = displayValues) === null || _displayValues === void 0 ? void 0 : _displayValues.map(function (i) {
        return i.label;
      }).join(',');
    } else {
      var _displayValues$;
      copyItem = (_displayValues$ = displayValues[0]) === null || _displayValues$ === void 0 ? void 0 : _displayValues$.label;
    }
    var handleCopyText = /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _navigator$clipboard;
        var formattedCopyItem, _navigator$clipboard2;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = !!copyItem;
              if (!_context.t0) {
                _context.next = 4;
                break;
              }
              _context.next = 4;
              return (_navigator$clipboard = navigator.clipboard) === null || _navigator$clipboard === void 0 ? void 0 : _navigator$clipboard.writeText(copyItem);
            case 4:
              formattedCopyItem = typeof copyFormatter === 'function' ? copyFormatter(copyItem) || '' : copyItem;
              if (!(typeof copyFormatter === 'function' && !!copyItem)) {
                _context.next = 8;
                break;
              }
              _context.next = 8;
              return (_navigator$clipboard2 = navigator.clipboard) === null || _navigator$clipboard2 === void 0 ? void 0 : _navigator$clipboard2.writeText(formattedCopyItem);
            case 8:
              if (props.onCopy && typeof props.onCopy === 'function') {
                props.onCopy(formattedCopyItem || copyItem);
              }
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleCopyText() {
        return _ref4.apply(this, arguments);
      };
    }();
    var copyableSize = size;
    if (size !== 'small' && size !== 'large') {
      copyableSize = 'medium';
    }
    return /*#__PURE__*/React.createElement(_StyledSelect.StyledSelect, (0, _extends2.default)({
      theme: theme,
      $open: mergedOpen,
      $focused: mockFocused,
      $combobox: mode === 'combobox',
      $disabled: disabled,
      $allowClear: !!props.allowClear,
      $template: !!template,
      $multiple: isMultiple,
      $size: size,
      className: mergedClassName,
      viewMode: viewMode
    }, domProps, {
      ref: containerRef,
      onMouseDown: onInternalMouseDown,
      onKeyDown: onInternalKeyDown,
      onKeyUp: onInternalKeyUp,
      onFocus: onContainerFocus,
      onBlur: onContainerBlur
    }), mockFocused && !mergedOpen && /*#__PURE__*/React.createElement(_StyledSelect.StyledSelectTextVisibility, null, /*#__PURE__*/React.createElement("span", {
      "aria-live": "polite"
    }, "".concat(mergedRawValue.join(', ')))), /*#__PURE__*/React.createElement(_StyledSelect.StyledSelectContentWrapper, {
      theme: theme,
      $copyable: copyable || !!copyFormatter,
      addonBefore: addonBefore,
      addonAfter: addonAfter,
      type: type,
      prefixCls: prefixCls,
      $backgroundColorType: backgroundColorType,
      $size: size,
      mode: mode
    }, (addonBefore || type === 'addon' && addonBefore) && /*#__PURE__*/React.createElement(_StyledSelect.StyledAddonBefore, {
      type: type,
      addonBefore: addonBefore,
      size: size
    }, addonBefore), /*#__PURE__*/React.createElement("div", {
      className: "SelectTriggerWrapper"
    }, /*#__PURE__*/React.createElement(_SelectTrigger.default, {
      ref: triggerRef,
      disabled: disabled,
      prefixCls: prefixCls,
      theme: theme,
      visible: triggerOpen,
      popupElement: popupNode,
      containerWidth: containerWidth,
      animation: animation,
      transitionName: transitionName,
      dropdownStyle: dropdownStyle,
      dropdownClassName: dropdownClassName,
      direction: direction,
      dropdownMatchSelectWidth: dropdownMatchSelectWidth,
      dropdownRender: dropdownRender,
      dropdownRenderHeader: dropdownRenderHeader,
      dropdownAlign: dropdownAlign,
      getPopupContainer: getPopupContainer,
      empty: !mergedOptions.length,
      getTriggerDOMNode: function getTriggerDOMNode() {
        return selectorDomRef.current;
      },
      onToggleOpen: onToggleOpen,
      scroll: scroll
    }, /*#__PURE__*/React.createElement(_Selector.default, (0, _extends2.default)({}, props, {
      autoAdd: activeAutoAdd,
      domRef: selectorDomRef,
      prefixCls: prefixCls,
      inputElement: customizeInputElement,
      ref: selectorRef,
      id: mergedId,
      showSearch: mergedShowSearch,
      mode: mode,
      accessibilityIndex: accessibilityIndex,
      multiple: isMultiple,
      tagRender: tagRender,
      values: displayValues,
      open: mergedOpen,
      onToggleOpen: onToggleOpen,
      searchValue: mergedSearchValue,
      activeValue: activeValue,
      onSearch: triggerSearch,
      onSearchSubmit: onSearchSubmit,
      onSelect: onInternalSelectionSelect,
      tokenWithEnter: tokenWithEnter,
      upperCase: upperCase
    }))), arrowNode, clearNode, (copyable || copyFormatter) && /*#__PURE__*/React.createElement(_StyledSelect.CopyButton, {
      onClick: handleCopyText,
      size: copyableSize,
      theme: theme
    }, /*#__PURE__*/React.createElement(_Tooltip.default, {
      placement: "top",
      overlay: props.locale.copy
    }, /*#__PURE__*/React.createElement(_StyledSelect.CopyIcon, {
      name: "clone",
      $size: copyableSize,
      color: "#fff",
      theme: theme
    })))), (addonAfter || type === 'addon' && addonAfter) && /*#__PURE__*/React.createElement(_StyledSelect.StyledAddonAfter, {
      type: type,
      addonAfter: addonAfter,
      size: size
    }, addonAfter)));
  }

  // Ref of Select

  var RefSelect = React.forwardRef(Select);
  return RefSelect;
}